import { Typography as T } from '@rmwc/typography';
import '@material/typography/dist/mdc.typography.css';
import styled from 'styled-components';

export const Typography = styled(T)`
  color: ${x => (x.rank ? x.theme.text[x.rank] : '')};
`;
export default Typography;
